import React from "react";
import { Box } from "@mui/material";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import KpiCard from "./KpiCard";

const UserStatsWidget = ({ stats, loading }) => {
  const total = stats?.totalUsers ?? 0;
  const activePct =
    total > 0 ? Math.round(((stats?.activeToday ?? 0) / total) * 100) : 0;

  return (
    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
      <KpiCard
        icon={PeopleAltOutlinedIcon}
        label="Total Users"
        value={stats?.totalUsers}
        loading={loading}
        color="#1976d2"
      />
      <KpiCard
        icon={TrendingUpOutlinedIcon}
        label="Active Today"
        value={stats?.activeToday}
        helper={total > 0 ? `${activePct}% of total` : null}
        loading={loading}
        color="#2e7d32"
      />
      <KpiCard
        icon={PersonAddAlt1OutlinedIcon}
        label="New This Month"
        value={stats?.newThisMonth}
        loading={loading}
        color="#9c27b0"
      />
      <KpiCard
        icon={LockOutlinedIcon}
        label="Locked Accounts"
        value={stats?.lockedAccounts}
        loading={loading}
        color={stats?.lockedAccounts > 0 ? "#d32f2f" : "#757575"}
      />
    </Box>
  );
};

export default UserStatsWidget;
